<template>
  <div class="dark:bg-dark-screen-background h-full overflow-hidden">
    <div class="p-5 h-full">
      <!-- <JourneysRow :journeys="journeys" :selected-journey="selected_journey" /> -->
      <JourneyPhases :selected-journey="currentJourney" :journeys="journeys" />
    </div>
  </div>
</template>

<script>
// import JourneysRow from "./JourneysRow.vue"
import JourneyPhases from "./JourneyPhases.vue"

export default {
  components: {
    // JourneysRow,
    JourneyPhases
  },
  props: {
    journeys: {
      type: Array,
      default: () => []
    },
    currentJourney: null
  },
  data() {
    return {}
  }
}
</script>
